import React, { useState, useEffect } from "react";
function FilePreview({ file }) {
  const [fileUrl, setFileUrl] = useState("");

  useEffect(() => {
    // Create a URL for the file
    if (!file) {
      return;
    }
    const url = URL.createObjectURL(file);
    setFileUrl(url);

    // Cleanup: revoke the object URL to avoid memory leaks
    return () => URL.revokeObjectURL(url);
  }, [file]);

  const getExtension = (filename) => {
    return filename.split(".").pop();
  };

  const isDocument = (extension) => {
    return ["pdf", "doc", "docx", "txt", "eml", "msg"].includes(extension);
  };

  const isImage = (extension) => {
    return ["jpg", "jpeg", "png", "webp"].includes(extension);
  };

  return (
    <div>
      {/* Only display the iframe if there is a file */}
      {file && isDocument(getExtension(file?.name)) && (
        <iframe
          src={fileUrl}
          style={{ width: "100%", height: "700px" }}
        ></iframe>
      )}
      {file && isImage(getExtension(file?.name)) && (
        <img src={fileUrl} alt={file?.name} style={{ width: "100%" }} />
      )}
    </div>
  );
}

export default FilePreview;
